import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Calendar } from 'primeng/calendar';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../../shared/alpha-shared.module';

@Component({
    selector: 'app-filter-date-range',
    standalone: true,
    templateUrl: './filter-date-range.component.html',
    styleUrl: './filter-date-range.component.scss',
    imports: [...PrimeNGModules, ReactiveFormsModule, TranslatePipe],
})
export class FilterDateRangeComponent implements OnInit, OnChanges {
    @Input() formGroup!: FormGroup;
    @Input() controlName: any;
    @Input() dateFormat!: string;
    @Input() label!: string;
    @Input() hide: boolean = false;
    @ViewChild('calendar') calendar!: Calendar;
    dateRange!: Date[] | null;

    constructor() {
        //[AL-3873]if calendar value is initialized with [] (empty array) then on selecting year it throws error,
        // so if no value is there initialize with null
        this.dateRange = null;
    }

    ngOnInit(): void {
        this.updateDateRange();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['formGroup'] || changes['controlName']) {
            this.updateDateRange();
        } else if (changes['hide']) {
            if (this.hide) {
                this.calendar.hideOverlay();
            }
        }
    }

    private updateDateRange(): void {
        const control = this.formGroup.get([this.controlName]);
        if (control) {
            const value = control.value?.value;
            if (value && Array.isArray(value) && value.length >= 1) {
                this.dateRange = [new Date(value[0]), value[1] ? new Date(value[1]) : new Date(value[0])];
            } else {
                this.dateRange = null;
            }
        }
    }

    onDateRangeChange(dateRange: Date[]) {
        if (dateRange && dateRange.length === 2) {
            // Set time of first date to 00:00
            dateRange[0]?.setHours(0, 0, 0, 0);
            // Set time of last date to 23:59
            dateRange[1]?.setHours(23, 59, 59, 999);
            this.dateRange = dateRange;
        }
    }

    onClickOutSide(calendar: Calendar): void {
        if (this.dateRange?.length && this.dateRange.some((date) => !date)) {
            calendar.overlayVisible = true;
        }
    }

    onClear(calendar: Calendar) {
        calendar.clear();
    }

    onToday(calendar: Calendar, event: Event) {
        calendar.onTodayButtonClick(event);
    }
}
